<template>
  <el-form ref="registerForm" :model="formData.obj" :rules="rules" label-position="top">
    <el-form-item :label="$t('message.home.username')" prop="username">
      <el-input v-model="formData.obj.username" maxlength="16" :placeholder="$t('message.home.pleaseEnterUsername')" />
    </el-form-item>
    <el-form-item :label="$t('message.home.password')" prop="password">
      <el-input v-model="formData.obj.password" :type="showPassword ? 'password' : 'text'"
        :placeholder="$t('message.home.pleaseEnterPassword')">
        <template slot="suffix">
          <img class="password-icon" :src="showPassword ? imageMap.close : imageMap.open"
            @click="showPassword = !showPassword" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.confirmPassword')" prop="rePassword">
      <el-input :type="showConfirm ? 'password' : 'text'" v-model="formData.obj.rePassword"
        :placeholder="$t('message.home.plaseeENterConfirmPassword')">
        <template slot="suffix">
          <img class="password-icon" :src="showConfirm ? imageMap.close : imageMap.open"
            @click="showConfirm = !showConfirm" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.orderEmail')" prop="email">
      <el-input v-model="formData.obj.email" :placeholder="$t('message.home.pleaseEnterEmail')" maxlength="64" />
    </el-form-item>
    <el-form-item :label="$t('message.home.mobilePhone')" prop="mobile">
      <el-input v-model="formData.obj.mobile" :placeholder="$t('message.home.pleaseEnterPhoneNumer')" maxlength="15" />
    </el-form-item>
    <el-form-item :label="$t('message.home.verificationCode')" prop="code">
      <el-row :gutter="6" style="width:100%">
        <el-col :span="15">
          <el-input v-model.trim="formData.obj.code" :maxlength="code.len"
            :placeholder="$t('message.home.pleaseEnterVerificationCode')" @keyup.enter.native="submitForm" />
        </el-col>
        <el-col :span="9">
          <div class="login-code">
            <img :src="code.src" class="login-code-img" @click="refreshCode" />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <p class="tips">
        {{ $t("message.home.loginTips") }}
        <span @click="goLogin">{{ $t("message.home.loginIn") }}</span>
      </p>
      <el-button class="sing-in-btn" type="primary" :loading="loading" @click="submitForm">
        {{ $t("message.home.signUp") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import common from "@/util/common";
import { randomLenNum } from '@/util/util.js'
import { submit } from '@/api/upms/register.js'

export default {
  name: "EsUsernameForm",
  data() {
    return {
      loading: false,
      showPassword: true,
      showConfirm: true,
      code: {
        src: '/code',
        len: 4,
      },
      imageMap: {
        open: require("@/assets/image/eye-open.png"),
        close: require("@/assets/image/eye-close.png"),
      },
      formData: {
        obj: { username: '', password: '', rePassword: '', email: '', mobile: '', code: '', randomStr: '' },
      },
      rules: {
        username: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterUsername")),
        ],
        password: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterPassword")),
          common.ruleUtils.getRule("password"),
        ],
        rePassword: [
          common.ruleUtils.getRule("required", this.$t("message.home.plaseeENterConfirmPassword")),
          common.ruleUtils.getRule("validator", "", {
            validator: (rule, value, callback) => {
              if (value !== this.formData.obj.password) {
                callback(new Error(this.$t("message.home.twoPawword")));
                return;
              }
              callback();
            },
          }),
        ],
        email: [
          common.ruleUtils.getRule("validator", "", {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback();
                return;
              }
              const emailRule = /^([A-Za-z0-9_\-\.\w{3,}])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
              if (!emailRule.test(value)) {
                callback(new Error(this.$t("message.home.validatorEmail")));
                return;
              }
              callback();
            },
          }),
        ],
        mobile: [
          common.ruleUtils.getRule("validator", "", {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback();
                return;
              }
              if (!/^[\d]{1,20}$/.test(value)) {
                callback(new Error(this.$t("message.home.validatorPhone")));
                return;
              }
              callback();
            },
          }),
        ],
        code: [
          common.ruleUtils.getRule("required", this.$t("message.home.pleaseEnterVerificationCode")),
        ],
      },
    };
  },
  mounted() {
    this.refreshCode();
  },
  activated() {
    this.refreshCode();
  },
  methods: {
    refreshCode() {
      this.formData.obj.code = '';
      this.formData.obj.randomStr = randomLenNum(this.code.len, true);
      this.code.src = this.publicGlobalUrl + '/code?randomStr=' + this.formData.obj.randomStr;
    },
    handleRegisterError(err) {
      this.refreshCode();
      this.$nextTick(() => {
        this.$refs.registerForm && this.$refs.registerForm.clearValidate('code');
      });
      const msg = err && err.response && err.response.data && err.response.data.message;
      if (msg) {
        this.$message.error(msg);
      }
    },
    submitForm() {
      this.$refs.registerForm.validate(valid => {
        if (!valid) return;
        if (this.formData.obj.rePassword !== this.formData.obj.password) {
          this.$message.error(this.$t("message.home.twoPawword"));
          return;
        }
        this.loading = true;
        const spreadUserId = localStorage.getItem("spreadUserId");
        const params = {
          username: this.formData.obj.username,
          password: this.formData.obj.password,
          code: this.formData.obj.code,
          randomStr: this.formData.obj.randomStr,
        };
        const email = (this.formData.obj.email || '').trim();
        const mobile = (this.formData.obj.mobile || '').trim();
        if (email) params.email = email;
        if (mobile) params.mobile = mobile;
        if (spreadUserId) params.spreadUserId = spreadUserId;
        submit(params).then(() => {
          this.$message.success(this.$t("message.home.registerSuccess"));
          this.$router.replace("/login");
        }).catch((err) => {
          this.handleRegisterError(err);
        }).finally(() => { this.loading = false; });
      });
    },
    goLogin() {
      sessionStorage.setItem("path", "/register");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.login-code {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}

.login-code-img {
  width: 100%;
  max-width: 120px;
  height: 50px;
  background-color: #fdfdfd;
  border: 1px solid #f0f0f0;
  cursor: pointer;
  object-fit: contain;
}
</style>
